module.exports = __webpack_public_path__ + "img/open_email.86940262.svg";